import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtService } from '@core/services/jwt.service';

@Injectable({
  providedIn: 'root'
})
export class BaseHttpService {
  constructor(private jwtService: JwtService,  public http: HttpClient) {}
  

  protected getAuthHeaders(): HttpHeaders {
    const token = this.jwtService.getToken();
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }


  protected getAuthHeadersMultPart(): HttpHeaders {
    const token = this.jwtService.getToken();
    return new HttpHeaders({
      'accept': '*/*',
      'Authorization': `Bearer ${token}`
    });
  }

  protected retreiveAllFromKey(url: string, body: any) {
   return this.http.post<any[]>(url, body  ,{ headers: this.getAuthHeaders() })
  }

  protected retreiveFromKey(url: string, body: any) {
    return this.http.post<any>(url, body  ,{ headers: this.getAuthHeaders() })
   }

   protected getUserByToken() {
    return this.jwtService.decodeToken();
   }
   

}
